<template>
  <b-form-group
    label="Veri Tipi"
    label-for="components"
  >
    <validation-provider
      #default="{ errors }"
      name="Veri Tipi"
      rules=""
    >
      <v-select
        id="components"
        v-model="dataItem.components"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Veri Tipi"
        multiple
        :close-on-select="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'TrashBinComponentSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return [
        {
          id: 'projects',
          title: 'Proje Kartı',
        },
        {
          id: 'services',
          title: 'Hizmet Kartı',
        },
        {
          id: 'products',
          title: 'Ürün Kartı',
        },
        {
          id: 'project_files',
          title: 'Proje Dokümanı',
        },
        {
          id: 'service_files',
          title: 'Hizmet Dokümanı',
        },
        {
          id: 'product_files',
          title: 'Ürün Dokümanı',
        },
      ]
    },
    dataItem() {
      return this.$store.getters['trashBin/filterParams']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
